import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';
import { MatIconModule } from '@angular/material/icon';
import { MinutesSecondsPipe } from './minutes-seconds.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';
// import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

@NgModule({
  declarations: [LoginComponent, ClickOutsideDirective, TwoFactorAuthenticationComponent, MinutesSecondsPipe],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule
  ],
  exports: [LoginComponent],
  providers: [MinutesSecondsPipe]
})
export class UserModule { }
